import i18n from "@/lib/i18n";

export const formatCurrency = new Intl.NumberFormat('vi-VN', {
  style: 'currency',
  currency: 'VND'
});

export const formatCurrencyUSD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const getFormatCurrency = (value: any) => {
  if (i18n.language === 'en' && typeof localStorage !== 'undefined') {
    const exchange = JSON.parse(localStorage.getItem('currency') || '[]')[0]
    const rate = parseFloat(exchange?.rate)
    if (!!exchange && Number.isFinite(rate) && rate > 0) {
      // rate = VND per 1 USD, so VND -> USD is a division
      return formatCurrencyUSD.format(value / rate)
    }
  }
  return formatCurrency.format(value)
}